import {useCallback} from "react";

import {disconnectAccount} from "../../../wallet/account/useDisconnectAccount";
import {WalletContextReducerAction} from "../../../wallet/util/context/WalletContext.types";
import {
  getSelectedAccountAddressFromWebStorage,
  getWalletTypeFromWebStorage,
  isPeraWallet
} from "../../../wallet/util/walletUtils";
import peraWalletManager from "../pera-wallet/PeraWalletManager";

/**
 * Tries to reconnect the Pera Wallet session
 * if the stored wallet type is pera-wallet
 * and there is a stored selected account address value
 */
function useReconnectPeraWallet(dispatch: React.Dispatch<WalletContextReducerAction>) {
  return useCallback(async () => {
    const storedAddress = getSelectedAccountAddressFromWebStorage();
    const storedWalletType = getWalletTypeFromWebStorage();

    if (isPeraWallet(storedWalletType) && storedAddress) {
      try {
        await peraWalletManager.reconnectSessionAndSetupEventHandlers({
          onDisconnect: () => disconnectAccount({dispatch})
        });
      } catch (error) {
        disconnectAccount({dispatch});
      }
    }
  }, [dispatch]);
}

export default useReconnectPeraWallet;
